import React, { PureComponent, PropTypes } from 'react';
import { Icon } from 'react-fast-ui';

const CENTERED = { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' };
const DEFAULT_CHILDREN_STYLE = { fontSize: 20, textAlign: 'center', color: 'lightgray', fontWeight: 'bolder' };

export default class EmptyState extends PureComponent {
  static propTypes = {
    iconProps: PropTypes.object
  };

  static defaultProps = {
    height: 300,
    iconProps: {
      name: 'dribbble',
      className: 'transform-rotate-150'
    }
  };

  render() {
    const { height, iconProps, children, ...rest } = this.props;

    return (
      <div style={{ position: 'relative', height }} {...rest}>
        <div className="color-lightest-gray" style={{ ...CENTERED, fontSize: 192 }}>
          <Icon {...iconProps}/>
        </div>

        <div style={{ ...DEFAULT_CHILDREN_STYLE, ...CENTERED }}>
          {children}
        </div>
      </div>
    );
  }
};

// define some reusable empty states
EmptyState.LOADING = <EmptyState iconProps={{ animate: 'spin', name: 'dribbble' }}>Loading...</EmptyState>;
EmptyState.ERROR = <EmptyState iconProps={{ name: 'exclamation-triangle' }}>An error occurred!</EmptyState>;



// WEBPACK FOOTER //
// ./src/js/common/components/EmptyState.jsx